export default __webpack_public_path__ + "static/media/044-sociology.a23ac70f.svg";